import React from 'react';
import { CheckCircle } from 'lucide-react';

const BookingProgressSteps = ({ steps, currentStep }) => {
  return (
    <div className="mb-6 sm:mb-8 lg:mb-12">
      <div className="flex items-center justify-between overflow-x-auto pb-2">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex items-center flex-shrink-0">
              <div
                className={`flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full border font-light transition-all text-xs sm:text-sm ${
                  currentStep >= step.id
                    ? 'bg-black text-white border-black'
                    : 'bg-white text-gray-400 border-gray-300'
                }`}
              >
                {currentStep > step.id ? (
                  <CheckCircle className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
                ) : (
                  step.id
                )}
              </div>
              <span
                className={`ml-2 sm:ml-3 text-xs sm:text-sm font-medium hidden sm:inline ${
                  currentStep >= step.id ? 'text-black' : 'text-gray-400'
                }`}
              >
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 mx-2 sm:mx-4 h-0.5 min-w-[20px] ${
                  currentStep > step.id ? 'bg-black' : 'bg-gray-300'
                }`}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BookingProgressSteps;

